import type { WheelPickerOption } from '~/shared/ui/WheelPicker'

/** Месяцы в родительном падеже — своего списка копирайта под пикер дат в 08_copy нет. */
export const MONTH_NAMES_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
] as const

/** Ширина барабанов — спека: день 1, месяц 1.6, год 1.2. */
export const DAY_WHEEL_FLEX = 1
export const MONTH_WHEEL_FLEX = 1.6
export const YEAR_WHEEL_FLEX = 1.2

/** Высота зоны барабанов в DatePickerSheet — спека 190px. */
export const DATE_WHEEL_HEIGHT_PX = 190

/** Разумный дефолт нижней границы диапазона дат, если minDate не задан. */
export const DEFAULT_MIN_DATE = new Date(1940, 0, 1)

/** Месяцы от `fromMonth` до `toMonth` включительно (0..11) — в крайнем году список короче. */
export function buildMonthOptions(fromMonth: number, toMonth: number): WheelPickerOption[] {
  const options: WheelPickerOption[] = []
  for (let month = fromMonth; month <= toMonth; month++) {
    const label = MONTH_NAMES_GENITIVE[month]
    if (label) options.push({ value: String(month), label })
  }
  return options
}

/** Дни от `fromDay` до `toDay` включительно — в крайнем месяце список обрезан границей. */
export function buildDayOptions(fromDay: number, toDay: number): WheelPickerOption[] {
  const options: WheelPickerOption[] = []
  for (let day = fromDay; day <= toDay; day++) {
    options.push({ value: String(day), label: String(day) })
  }
  return options
}

export function buildYearOptions(minYear: number, maxYear: number): WheelPickerOption[] {
  const options: WheelPickerOption[] = []
  for (let year = minYear; year <= maxYear; year++) {
    options.push({ value: String(year), label: String(year) })
  }
  return options
}
